import { AppBar, Drawer, Grid, List, ListItem, Tooltip, Typography, makeStyles } from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit';
import React, { Fragment, useState } from 'react'
import Delete from '@material-ui/icons/Delete';
import { useDispatch, useSelector } from 'react-redux';
import { getImageMapData } from '../../../../store/global/selectors';
import { setImageMapData } from '../../../../store/global/actions';
import DrawerHeader from '../../../atoms/drawerHeader';
import AlertDialog from '../../../atoms/alertDialog/AlertDialog.js'
import LoaderWithProgress from '../../../atoms/loader/LoaderWithProgress.js';


const useStyles = makeStyles((theme) => ({
    drawerContainer: {
        height: 'calc(100vh - 128px)',
        width: '15rem',
        top: '128px',
        boxShadow: '0px 5px 10px rgba(0,0,0,0.05)',
        cursor: 'auto'
    },
    drawerRoot: {
        zIndex: 3000,
        width: '15rem',
        height: 'calc(100vh - 128px)',
        '& .MuiBackdrop-root': {
            display: 'none'
        }
    },
    drawerHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0.5rem',
        color: theme.palette.primary.contrastText,
        flexDirection: 'row',
        background: theme.palette.primary.main
    },
    drawerHeaderTitle: {
        fontSize: '1.1rem',
        fontWeight: 500,
    },
    drawerSelectedAreaButton: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: '1px solid rgba(0,0,0,0.2)'
    },
    drawerEditIcon: {
        outline: 'none',
        cursor: 'pointer',
        fontSize: '19px',
        marginLeft: '0.5rem',
        color: '#3f4e5c'
    },
    drawerDeleteIcon: {
        outline: 'none',
        cursor: 'pointer',
        fontSize: '19px',
        marginLeft: '0.5rem',
        color: '#f50057'
    },
    selecteAreaButtonsContainer: {
        minWidth: '60px'
    },
    selectedAreaName: {
        marginLeft: '5px'
    }
}))

export default function SelectedAreaDrawer({ isOpened, isFetching }) {
    const classes = useStyles();
    const dispatch = useDispatch();

    const [isDialogOpen, setDialogOpen] = useState(false);

    const { areas } = useSelector(getImageMapData);

    const handleAreaDeletion = (area) => {
        setDialogOpen(area)

    }

    const handleOnProceed = () => {
        let filteredAreas = areas.filter((currentArea) => isDialogOpen !== currentArea);
        dispatch(setImageMapData({ areas: filteredAreas }))
        setDialogOpen(false);
    }

    const onEditArea = (area) => {
        dispatch(setImageMapData({ selectedAreaName: area?.name, shapeToEdit: area?.name }));
    }

    return (
        <Fragment>
            <AlertDialog
                open={isDialogOpen ? true : false}
                title='Delete'
                content={`Are you sure to delete ${isDialogOpen?.name}?`}
                proceedText='Delete'
                proceedColor='secondary'
                abortColor='primary'
                onClose={() => setDialogOpen(false)}
                onProceed={handleOnProceed}
            />
            <Drawer
                open={isOpened}
                onClose={() => setDialogOpen(false)}
                anchor='left'
                classes={{
                    paper: classes.drawerContainer,
                    root: classes.drawerRoot
                }}
                disablePortal
                style={{ zIndex: 3000, top: '128px' }}
                id={"selectedAreaDrawer"}
            >
                <AppBar position='static' className={classes.drawerHeader}>
                    <Grid container>
                        <Grid item xs={12} align={'center'} direction={'column'} justify={'center'}>
                            <h6 style={{ marginTop: 10 }}><DrawerHeader name="Selected Areas" /> </h6>
                        </Grid>
                    </Grid>
                </AppBar>
                {isFetching ?
                    <LoaderWithProgress size={20} isContent={true} styleRoot={{ marginTop: 'calc((100vh - 192px)/2)' }} />
                    :
                    <List component='nav' aria-label='selected area list'>
                        {
                            areas?.length > 0 ?
                                <>
                                    {
                                        areas?.map((area) => (
                                            <ListItem className={classes.drawerSelectedAreaButton}>
                                                <Typography noWrap  className={classes.selectedAreaName}>{area.name}</Typography>
                                                <Grid className={classes.selecteAreaButtonsContainer}>
                                                    <Tooltip title='Edit Properties'>
                                                        <EditIcon onClick={() => onEditArea(area)} button className={classes.drawerEditIcon} />
                                                    </Tooltip>
                                                    <Tooltip title='Delete Area'>
                                                        <Delete
                                                            button
                                                            className={classes.drawerDeleteIcon}
                                                            onClick={() => handleAreaDeletion(area)}
                                                        />
                                                    </Tooltip>
                                                </Grid>
                                            </ListItem>
                                        ))
                                    }
                                </>
                                :
                                <ListItem className={classes.drawerSelectedAreaButton} style={{ borderBottom: 'none' }}>
                                    <Typography noWrap>No areas selected</Typography>
                                </ListItem>
                        }

                    </List>
                }
            </Drawer>
        </Fragment>
    )
}
